export const formatRankStatus = (status: string): string =>
  status.toLowerCase() === 'error' ? 'Unable to Predict' : status
